import cogoToast from 'components/ToastMessage/ToastMessage';

export const toQueryParams = (array: string[], key: string) => {
  return array.map((item) => `${key}=${encodeURIComponent(item)}`).join('&');
};

export const displayError = (details?: string, description?: string) => {
  if (description || details) {
    const formattedErrorDetails = details && details.length > 500 ? `${details.slice(0, 500)}...` : details;
    // Show our best formatted error details, or description as a fallback...
    cogoToast.error(`${formattedErrorDetails || description}`, { hideAfter: 5 });
  } else {
    cogoToast.error('An unknown error occurred, please contact support.', { hideAfter: 5 });
  }

  console.error(description, details);
};
